import React, { useEffect, useState } from "react";
import { baseUrl } from '../library/comoda';

interface Sito {
  nome: string;
  url: string;
  favicon: string;
  attivo: string; // "t" o "f"
}

const ListaSiti: React.FC = () => {
  const [siti, setSiti] = useState<Sito[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSiti = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${baseUrl}listasiti.php`);
        const data = await res.json();
        setSiti(data);
      } catch {
        setError("Errore di rete");
      } finally {
        setLoading(false);
      }
    };

    fetchSiti();
  }, []);

  return (
    <div className="box background altezzafissa">
      <h1>Lista siti</h1>
      {loading && <p>Caricamento...</p>}
      {error && <p>{error}</p>}
      <div className="lista-siti">
        {siti.filter(s => s.attivo === "t").map((sito, index) => (
          <div key={index} className="sito-item">
            <a className="custom-link" target="_blank" rel="noreferrer" href={sito.url}>
              <img className="logo-sito" src={sito.favicon} alt={sito.nome} />
              {sito.nome}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListaSiti;
